import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      addNotification: 'notification/add',
    }),

    createNotification(type, message) {
      const notification = {
        type,
        message,
      };
      this.addNotification(notification);
      this.$modal.show('are-you-sure');
    },

    checkSessionErrorNotification(error) {
      if (error.response && (error.response.request.status === 401 || error.response.request.status === 419)) {
        this.createNotification('info', `${this.$t('notifications.expiredSession')}`);
        this.$router.push(`/signin?redirect=${this.$router.currentRoute.path}`);
        return;
      }
      this.createNotification('error', `${this.$t('notifications.errorTryAgain')}`);
    },

    checkRoutingAuthentication(error) {
      if (error.response.request.status === 401 || error.response.request.status === 419) {
        if (!this.$store.getters['notification/notifications'].find((notification) => notification.type === 'session')) {
          this.createNotification('session', `${this.$t('notifications.expiredSession')}`);
          this.$store.dispatch('auth/me');
        }
        this.$router.push(`/signin?redirect=${'/'}`).catch(() => {});
        return;
      }
      this.createNotification('error', `${this.$t('notifications.errorReload')}`);
    },
  },
};
